import {invokeApi} from '../bl_libs/invokeApi';
import {LOCAL_STORAGE_KEYS} from "../utils/constants";

export const createRatingProgramService = (rating_type) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/new',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        rating_type
    };

    return invokeApi(requestObj);
}

export const fetchRatingProgramService = (programId) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/fetch',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        'application_id': programId
    };

    return invokeApi(requestObj);
}

export const fetchRatingProgramStatusService = (programId) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/fetch/status',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        'application_id': programId
    };

    return invokeApi(requestObj);
}

export const uploadMedia = (formData, progressCb) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/upload/content',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`,
            'content-type': 'multipart/form-data'
        },
        onUploadProgress: progressCb
    };
    requestObj['postData'] = formData

    return invokeApi(requestObj);
}

export const submitProgramDataService = (programId, files_path) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/submit/program/data',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`,
        },
    };
    requestObj['postData'] = {
        'application_id': programId,
        files_path
    };

    return invokeApi(requestObj);
}

export const updateCompanyInfoService = (data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/update/company_info',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`,
        },
    };
    requestObj['postData'] = {
        ...data
    };

    return invokeApi(requestObj);
}

export const updateProgramInfoService = (programId, data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/update/extra_info',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`,
        },
    };
    requestObj['postData'] = {
        'application_id': programId,
        ...data
    };

    return invokeApi(requestObj);
}

export const fetchAllRatingProgramsService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/list',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
    };

    return invokeApi(requestObj);
}

export const updateProgramStatusService = (programId, app_status) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/update/status',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        'application_id': programId,
        'application_status': app_status
    };

    return invokeApi(requestObj);
}

export const applyPromoCodeService = (programId, promo_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/apply_promo_code',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        'application_id': programId,
        'promo_code': promo_code
    }

    return invokeApi(requestObj);
}

export const enableAssessmentService = (programId) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/enable_assessment',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        'application_id': programId,
    }

    return invokeApi(requestObj);
}

export const downloadBadgeService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/download_badge',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
    }

    return invokeApi(requestObj);
}

export const publishProgramAssessmentService = (programId) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/rating/program/publish/assess',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        'application_id': programId,
    };

    return invokeApi(requestObj);
}